export function decodeL500Token(token) {
    const parts = token.split(".");
    if (parts.length !== 3)
        return null;
    try {
        const payloadBase64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = payloadBase64 + "=".repeat((4 - (payloadBase64.length % 4)) % 4);
        const bytes = Uint8Array.from(atob(padded), character => character.charCodeAt(0));
        const parsed = JSON.parse(new TextDecoder("utf-8", { fatal: true }).decode(bytes));
        return { ...parsed, scopedRoles: parsed.scopedRoles ?? [] };
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=decodeL500Token.js.map